class SizeChartPopup extends HTMLElement {
    constructor() {
        super();
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }

    connectedCallback() {
        this.backdrop = this.querySelector('[data-backdrop]');
        this.closeBtn = this.querySelector('[data-close-btn]');
        this.unitButtons = this.querySelectorAll('.sc-unit-btn');
        this.unitContents = this.querySelectorAll('[data-unit-content]');

        this._initEvents();
    }

    _initEvents() {
        // Button clicks inside component
        if (this.closeBtn) this.closeBtn.addEventListener('click', this.close);

        if (this.backdrop) {
            this.backdrop.addEventListener('click', (e) => {
                if (e.target === this.backdrop) this.close();
            });
        }

        this.unitButtons.forEach(btn => {
            btn.addEventListener('click', () => this._handleUnitToggle(btn));
        });

        // Global listener for the trigger button
        document.addEventListener('open-size-chart', () => this.open());

        // ESC key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') this.close();
        });
    }

    open() {
        if (this.backdrop) {
            this.backdrop.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        }
    }

    close() {
        if (this.backdrop) {
            this.backdrop.style.display = 'none';
            document.body.style.overflow = '';
        }
    }

    _handleUnitToggle(activeBtn) {
        const targetUnit = activeBtn.dataset.unit;

        this.unitButtons.forEach(btn => {
            btn.classList.toggle('sc-unit-btn--active', btn === activeBtn);
        });

        this.unitContents.forEach(content => {
            content.style.display = (content.dataset.unitContent === targetUnit) ? 'block' : 'none';
        });
    }
}

if (!customElements.get('size-chart-popup')) {
    customElements.define('size-chart-popup', SizeChartPopup);
}